import { render } from "./SettingsBar.vue?vue&type=template&id=59e22b1e"
import script from "./SettingsBar.vue?vue&type=script&lang=js"
export * from "./SettingsBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__